import { COLORS, newLayout } from '../theme';

export default {
  styleOverrides: {
    root: {
      '.MuiInputBase-input': {
        transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        fontWeight: newLayout.fontWeight.medium,
      },
      '&:not(.MuiInputBase-colorError):not(.MuiInputBase-colorSuccess):not(.Mui-disabled):hover, &:not(.MuiInputBase-colorError):not(.MuiInputBase-colorSuccess).Mui-focused ':
        {
          color: COLORS.kinetikBlack,
        },
      '&.Mui-disabled': {
        svg: {
          color: COLORS.black30,
          path: {
            fill: COLORS.black30,
          },
        },
      },
      '&.MuiInputBase-readOnly': {
        pointerEvents: 'none',
      },
    },
  },
};
